import { ReactElement } from 'react';
import Label from '../../../../../../common/label/label';
import MaterialOwner from '../../../../../../common/material/material-long/template/components/material-owner/material-owner';
import cn from '../../../../../../utils/classnames';
import MaterialCardRating from '../../components/material-card-rating/material-card-rating';
import MaterialImage from '../../components/material-image/material-image';
import MaterialSchoolLabel from '../../components/material-school-label/material-school-label';
import MaterialTitle from '../../components/material-title/material-title';
import { useCardContext } from '../../contexts/favorites-material-card-context';
import useCard from '../../hooks/use-card';
import { FavoritesMaterialCardVariationProps } from '../../types';
import handleLinkClick from '../../utils/handle-link-click';
import Footer from './components/footer/footer';
import './desktop-grid-card.scss';

const DesktopGridCard = (props: FavoritesMaterialCardVariationProps): ReactElement => {
    const { item, index, internalPath, hasSchoolLabel, banner } = props;
    const { shouldShowFolder, shouldShowAddToCart, onAddToCartSuccess } = props;

    const card = useCard({
        item,
        internalPath,
        screen: 'desktop',
        className: cn('grid-view', { 'with-school-label': hasSchoolLabel })
    });
    const { setCardNode } = useCardContext();

    const onImageClick = (): void => handleLinkClick({ item, index });

    return (
        <div ref={setCardNode} className={card.classNames} data-testid={card.testId}>
            {card.label && <Label item={item} />}

            {hasSchoolLabel && <MaterialSchoolLabel />}

            <MaterialImage
                item={item}
                imageSize='long-grid'
                onClick={onImageClick}
                index={index}
                internalPath={internalPath}
            />

            <MaterialTitle item={item} index={index} internalPath={internalPath} />

            <MaterialCardRating item={item} />

            <MaterialOwner item={item} />

            <Footer
                item={item}
                index={index}
                internalPath={internalPath}
                shouldShowFolder={shouldShowFolder}
                shouldShowAddToCart={shouldShowAddToCart}
                onAddToCartSuccess={onAddToCartSuccess}
            />

            {banner}
        </div>
    );
};

export default DesktopGridCard;
